module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_19_B_2.7251cd62.mp3";